var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "slider-cottage-listing" },
    [
      _c(
        "swiper-container",
        {
          ref: "swiper_" + _vm.item.ID,
          attrs: {
            "slides-per-view": 1,
            loop: true,
            init: "false",
            effect: _vm.getEffect,
            pagination: "true",
            "pagination-dynamic-bullets": "true",
          },
          on: { swiperslidechange: _vm.onSlideChange },
        },
        _vm._l(_vm.allMedia, function (media, index) {
          return _c(
            "swiper-slide",
            {
              key: media.mediaIndex + "-" + media.isVideo,
              attrs: { lazy: "true" },
            },
            [
              _vm.isSwiperInited
                ? _c(
                    "div",
                    {
                      staticClass: "gallery-one",
                      style: { "--sp-max-h": _vm.maxHeight + "px" },
                    },
                    [
                      !media.isVideo &&
                      (index === _vm.firstImageIndex ||
                        _vm.indexActive === index)
                        ? _c("img", {
                            attrs: {
                              src: media.src,
                              alt: _vm.item.NAME,
                              width: media.width,
                              height: media.height,
                              loading: "lazy",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      media.isVideo
                        ? _c("video", {
                            ref: "videos",
                            refInFor: true,
                            style: {
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            },
                            attrs: {
                              muted: "",
                              playsinline: "",
                              preload: "metadata",
                              src: media.src,
                              loading: "lazy",
                              poster: _vm.getPlaceholderImage(),
                            },
                            domProps: { muted: true },
                          })
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      !_vm.isMobile
        ? _c(
            "div",
            { staticClass: "gallery-control" },
            _vm._l(_vm.allMedia, function (media, index) {
              return _c("div", {
                key: "control-" + index,
                staticClass: "part-control",
                class: { active: media.active },
                style: "width:" + _vm.widthControl + "%",
                on: {
                  mouseenter: function ($event) {
                    return _vm.hoverControlMedia(index, media, _vm.item)
                  },
                },
              })
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }